import { useLocation } from 'react-router-dom';
import { useGetContractor, useShowBlockingBanner } from 'entities/profile';
import { pageRoutes } from 'shared/routes';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Tooltip } from 'shared/ui/Tooltip';
import { isImpersonate, removeImpersonateToken } from 'shared/lib/api';
import { BLOCKING_MESSAGE } from 'entities/campaign';
import { Banner } from 'app/Layout/Banner/Banner';

function BlockingBanner() {
  return (
    <Banner className="bg-deep-blue-500">
      <div className="mr-4 flex items-center text-sm text-white">
        <MaterialIcon className="pr-2">info</MaterialIcon>
        <span className="font-medium">{BLOCKING_MESSAGE}</span>
        <Tooltip
          placement="bottom-start"
          content={
            <p>
              From <span className="font-semibold">Friday</span> to <span className="font-semibold">Monday</span>, we
              are setting up our advertising campaigns to find high-quality leads for you. This is a meticulous process
              that requires some time. Please contact your manager with any questions.
            </p>
          }
        >
          <span className="cursor-pointer pl-4 font-semibold underline underline-offset-2">Read more</span>
        </Tooltip>
      </div>
    </Banner>
  );
}
function ImpersonatingBanner() {
  const companyName = useGetContractor().data?.data.companyName;

  return (
    <Banner className="bg-slate-800">
      <div className="mr-4 text-sm text-white">
        <span className="font-medium">You’re browsing as</span> <span className="font-semibold">{companyName}.</span>
      </div>
      <button
        className="rounded-sm bg-white px-4 py-2 text-xs font-medium"
        onClick={() => {
          removeImpersonateToken();
          window.location.href = '/';
        }}
      >
        Back to manager panel
      </button>
    </Banner>
  );
}

export function BannerContainer() {
  const { pathname } = useLocation();
  const showImpersonatedBanner = isImpersonate();
  const isCampaignPage = pathname.startsWith(pageRoutes.app.campaigns);
  const showBlockingBanner = useShowBlockingBanner() && isCampaignPage;

  return (
    <>
      {showImpersonatedBanner && <ImpersonatingBanner />}
      {showBlockingBanner && <BlockingBanner />}
    </>
  );
}
